import { OwnershipEnum } from '@jerry-serverless/types';

import type { AppData } from '../../types/app_data';
import type { Step } from '../types/step';

export const CarsLoadingStep: Step = {
  id: 'carsloading',
  pathname: '/carsloading',
  canShow: (appData: AppData) => {
    if (appData.signupParams?.askCoverageV4Variant === 3) {
      const nonFinancedCars = appData.selectedCars?.filter(
        (car) => car.ownership !== OwnershipEnum.Leased && car.ownership !== OwnershipEnum.Lien
      );
      if (
        nonFinancedCars &&
        nonFinancedCars.length > 0 &&
        nonFinancedCars.some((car) => !appData.carValues?.[car.id])
      ) {
        return true;
      }
    }
    return false;
  },
  hasData: () => true,
  hasOwnData: () => true,
};
